const HMNOT = () => import('./../views/Noticias.vue')
const Noti = () => import('./../views/Noticia.vue')
const Cat = () => import('./../views/Categorias.vue')
const Lnk = () => import('./../views/Links.vue')
const Gal = () => import('./../views/Galeria.vue')

export default [
  { name: 'viewSite', path: '/noticias', component: HMNOT, meta: { acl: true } },
  { name: 'viewNoticia', path: '/noticias/noticia', component: Noti, meta: { acl: true } },
  { name: 'viewCategorias', path: '/noticias/categorias', component: Cat, meta: { acl: true } },
  { name: 'viewLinks', path: '/noticias/links', component: Lnk, meta: { acl: true } },
  { name: 'viewGalerias', path: '/noticias/galerias-de-imagens', component: Gal, meta: { acl: true } }
]
